/**
 * Active SVG outline options for the Hero section.
 *
 * Controls which SVG overlay is shown on the active view (ModelView / VisualizationView).
 * Each outline is a separate SVG file fetched on demand.
 *
 * - BUILDINGS  — building footprints / mass outline (click → drill into building)
 * - TIERS      — floor / tier outlines (click → select tier)
 * - APARTMENTS — individual apartment outlines (click → open product sheet)
 *
 * Which values are actually available depends on `heroCapabilities.*OutlineLayers`
 * for the current `HERO_VIEW`.
 */
export const HERO_OUTLINE = {
  BUILDINGS:  'buildings',
  TIERS:      'tiers',
  APARTMENTS: 'apartments',
}
